/**
 * Save data and app state.
 *
 * @module saver
 */

'use strict';

var app        = require('mag-app'),
    uiDefaults = app.config.uiDefaults;


/**
 * Save app state.
 */
function saveState () {
    Object.keys(app.state).forEach(function ( state ) {
        if ( app.state[state] === uiDefaults[state] ) {
            delete app.state[state];
        }
    });

    core.state = app.state;
}


/**
 * Initialize saver for working with page.
 *
 * @param {boolean} saveStateOn - switcher for specifying if saving state is enabled
 * @param {boolean} saveDataOn - switcher for specifying if saving data is enabled
 *
 * @return {boolean} exit status
 */
function init ( saveStateOn, saveDataOn ) {
    core.state = core.state || {};
    app.state  = {};

    // restore state
    Object.keys(uiDefaults).forEach(function ( state ) {
        if ( saveStateOn ) {
            app.state[state] = core.state[state] === undefined ? uiDefaults[state] : core.state[state];
        } else {
            app.state[state] = uiDefaults[state];
        }
    });

    app.saveState = saveStateOn ? saveState : function () { /* action */ };

    if ( saveDataOn ) {
        // implement
    }

    return true;
}


module.exports = {
    init: init,
    saveState: saveState
};
